import React from 'react';
import { Link } from 'react-router-dom';
import Profile from './profile';
import { Button, Table } from 'react-bootstrap';
import transaction from '../../assets/images/profile/transaction-red.svg';
import nexticon from '../../assets/images/profile/arrow.svg';
import previcon from '../../assets/images/profile/arrow.svg';
import singelgem from '../../assets/images/header/gem.png';

const Transaction = () => {
  return (
    <Profile>
      <div className='transaction'>
        <div className='page-heading'>
          <h3>
            <img src={transaction} alt='' /> Transactions
          </h3>
        </div>

        <div className='transaction-content'>
          <Table striped bordered variant='dark' responsive>
            <thead>
              <tr>
                <th>Type</th>
                <th>Time</th>
                <th>Wagered</th>
                <th>Transaction</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Deposit</td>
                <td>4:09 PM</td>
                <td>
                  <div className='transaction-value'>
                    <img src={singelgem} alt='' /> $259.25
                  </div>
                </td>
                <td>
                  <div className='transaction-item'>
                    <Link>1d86ce14dfd9235899457019c85422...</Link>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>

          <div className='pagination'>
            <Button className='disabled'>
              <img src={previcon} alt='' /> Previous Page
            </Button>

            <Button>
              Next Page <img src={nexticon} alt='' />
            </Button>
          </div>
        </div>
      </div>
    </Profile>
  );
};

export default Transaction;
